export const colors = {
  // Ijroda
  // // 1: "#eee20d",
  // 4: "#eecb0d",
  // // javob kutilyotgan
  // // 2: "#93e812",
  // 5: "#7ee812",
  // // tasdiqlangan
  // 3: "#0c811d",
  // 6: "#089e10",

  // 9: "#f30f0f",
  // 8: "#f61d1d",
  // 7: "#F50404",

  // comment color///////
  // 0: "#20AE84",
  // 1: "#B868AD",
  // 2: "#F9A54D",
  // 3: "#2986f5",
  // 4: "#7ee812",
  // 5: "#F98966",
  // 6: "#0c811d",
  // 7: "#96D90C",

  0: "#3399FF",
  1: "#00CC00",
  2: "#F9A54D",
  3: "#2986f5",
  4: "#7ee812",
  5: "#F98966",
  6: "#0c811d",
  7: "#96D90C",

  // 15: '#F46363',
  // 20: '#F76E43',
  // 25: '#F98966',
  // 30: '#F19172',
  // 35: '#E09270',
  // 40: '#D79173',
  // 45: '#BEAD17',
  // 50: '#DECC28',
  // 55: '#E9D94D',
  // 60: '#F4E456',
  // 65: '#F3E458',
  // 70: '#BFE968',
  // 75: '#A6E425',
  // 80: '#96D90C',
  // 85: '#85BF0E',
  // 90: '#37DC47',
  // 95: '#2AD73B',
}
